function sectionSliderInit({
  sliderId = '',
  autoPlay = false,
  delay = 5000,
  isControlHandlePlay = false,
  spaceBetween = 16,
  layoutType = 'none',
  arrowsType = 'none',
  slidesPerViewMobile = 1,
  slidesPerViewTablet = 1,
  slidesPerViewDesktop = 1,
  paginationType = 'none',
  transition,
  freeModeMobile = false,
  slidesOffsetMobile = 0,
  slidesOffsetDesktop = 0,
}) {
  const initHandleSliderAutoPlay = () => {
    btnPlayControl.addEventListener('click', () => {
      if (isPlaying) {
        swiper.autoplay.stop();

        resetProgressAnimation();
      } else {
        swiper.params.autoplay.delay = delay;
        swiper.autoplay.start();
        
        initProgressAnimation();
      }

      btnPlayControl.classList.toggle('playing');
      isPlaying = !isPlaying;
    });
  }

  const initProgressAnimation = () => {
    ring.style.transition = `stroke-dashoffset ${delay}ms linear`;
    ring.style.strokeDashoffset = 0;
  }

  const resetProgressAnimation = () => {
    ring.style.transition = 'none';
    ring.style.strokeDashoffset = 106.8;
  }

  const updateIndicatorPagination = () => {
    const activeBullet = document.querySelector('.bullet.active');
    const indicator = document.querySelector('.tabnav-indicator');

    if (activeBullet && indicator) {
      const bulletsPosX = getBulletsPosX() || 0;
      
      const width = activeBullet.getBoundingClientRect().width;
      
      let left = activeBullet.offsetLeft + 4;

      if (bulletsPosX < 0 || bulletsPosX > 0) {
        left = activeBullet.offsetLeft + 4 + bulletsPosX;
      }

      console.log('02 ', left);
      
      indicator.style.setProperty('--tabnav-indicator-width', `${width}px`);
      indicator.style.setProperty('--tabnav-indicator-left', `${left}px`);
    }
  }

  const updatePaddlesVisibility = () => {
    const totalScroll = bullets.scrollWidth;
    const visibleWidth = bullets.clientWidth;
    const scrollLeft = bullets.scrollLeft;

    if (visibleWidth >= totalScroll) {
      paddles.classList.remove('show');
      return;
    }

    paddles.classList.add('show');

    const canScrollLeft = scrollLeft > 0;
    const canScrollRight = scrollLeft + visibleWidth < totalScroll - 1;

    console.log('teste', canScrollLeft);
    console.log('teste', canScrollRight);

    if (canScrollLeft) {
      paddles.classList.remove('next');
    } else {
      paddles.classList.add('next');
    }

    if (canScrollRight) {
      paddles.classList.remove('prev');
    } else {
      paddles.classList.add('prev');
    }
  }

  const getBulletsPosX = () => {
    console.log(bullets);
    
    return parseFloat(bullets.style.getPropertyValue('--bullets-pos-x'));
  }

  const elemSlider = document.getElementById(sliderId);
  
  let isPlaying = autoPlay;

  const btnPlayControl = elemSlider.querySelector('#swiper-toggle-autoplay');
  const ring = elemSlider.querySelector('.ring-fill');
  const swiperPagination = elemSlider.querySelector('.swiper-pagination-custom');

  let bullets = null;
  let paddles = null;
  let prevBtn = null;
  let nextBtn = null;

  const config = {
    slidesPerView: 'auto',
    freeMode: freeModeMobile,
    speed: 1000,
    spaceBetween,
    slidesOffsetBefore: slidesOffsetMobile,
    slidesOffsetAfter: slidesOffsetMobile,
    breakpoints: {
      1024: {
        freeMode: false,
      },
      1512: {
        slidesOffsetBefore: slidesOffsetDesktop,
        slidesOffsetAfter: slidesOffsetDesktop,
        freeMode: false,
      }
    }
  }

  if (transition === 'fade') {
    config.effect = 'fade';
    config.fadeEffect = {
      crossFade: true,
    };
  }

  if (layoutType === 'items') {
    config.slidesPerView = slidesPerViewMobile;
    config.breakpoints = {
      768: {
        slidesPerView: slidesPerViewTablet,
      },
      ...config.breakpoints,
    }
    
    config.breakpoints['1024'].slidesPerView = slidesPerViewDesktop;
    config.breakpoints['1512'].slidesPerView = slidesPerViewDesktop;
  }

  if (autoPlay) {
    config.autoplay = {
      delay,
    }
  }

  if (arrowsType === 'arrow') {
    config.navigation = {
      nextEl: '.navigation .swiper-button-next-custom',
      prevEl: '.navigation .swiper-button-prev-custom',
    };
  }

  if (paginationType === 'text') {
    const labels = Array.from(document.querySelectorAll('.swiper-slide')).map(slide =>
      slide.getAttribute('data-slide-label')
    );

    config.pagination = {
      el: '.swiper-pagination-custom',
      type: 'custom',
      renderCustom: function (swiper, current, total) {
        return labels
          .map((label, i) => {
            const active = i + 1 === current ? 'active' : '';
            return `<button class="bullet ${active}" data-index="${i}">${label}</button>`;
          })
          .join('');
      },
    }
  }

  if (paginationType === 'scroll') {
    config.scrollbar = {
      el: ".swiper-scrollbar",
      draggable: true,
      enabled: true,
    }
  }

  if (paginationType === 'dots') {
    config.pagination = {
      el: '.swiper-pagination',
      clickable: true,
      type: 'bullets',
      renderBullet(index, className) {
        return `<span class="${className}"><i></i><b></b></span>`;
      },
    }
  }

  const swiper = new Swiper(elemSlider.querySelector('.swiper'), config);

  if (isControlHandlePlay) {
    initHandleSliderAutoPlay();

    swiper.on('slideChangeTransitionStart', () => {
      if (isPlaying) {
        resetProgressAnimation();

        setTimeout(() => {
          initProgressAnimation();
        }, 1000);
      }
    });

    if (isPlaying) {
      initProgressAnimation();
    }
  }

  if (paginationType === 'text') {
    bullets = elemSlider.querySelector('.wrapper__swiper-pagination .list-bullet .swiper-pagination-custom');
    paddles = elemSlider.querySelector('.wrapper__swiper-pagination .tabnav-paddles');
    prevBtn = elemSlider.querySelector('.wrapper__swiper-pagination .tabnav-paddles .prev');
    nextBtn = elemSlider.querySelector('.wrapper__swiper-pagination .tabnav-paddles .next');

    swiperPagination.addEventListener('click', event => {
      if (event.target.matches('.bullet')) {
        const index = Number(event.target.dataset.index);
        swiper.slideTo(index);
      }
    });

    updateIndicatorPagination();

    window.addEventListener('load', updatePaddlesVisibility());
    window.addEventListener('resize', updatePaddlesVisibility());

    swiper.on('slideChangeTransitionStart', () => {
      updatePaddlesVisibility();

      updateIndicatorPagination();
    });

    nextBtn.addEventListener('click', () => {
      const activeBullet = document.querySelector('.bullet.active');

      const currentIndex = Number(activeBullet.dataset.index);
      const nextIndex = currentIndex + 1;

      const width = activeBullet.getBoundingClientRect().width;

      const bulletsPosX = getBulletsPosX() || 0;
      
      bullets.style.setProperty(
        '--bullets-pos-x',
        `${bulletsPosX - (width / 2)}px`)
      ;

      swiper.slideTo(nextIndex);
    });
  }
}